import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './views/App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './store/storeConfig';
import {
  BrowserRouter as Router,
} from "react-router-dom";


ReactDOM.render(
  <Provider store={store}>
    <React.StrictMode>
      <Router basename={(() => { const b = process.env.REACT_APP_PUBLIC_URL; return (b && b.startsWith('/')) ? b : '/'; })()}>
        <App />
      </Router>
    </React.StrictMode>
  </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
